import React, { Component } from 'react'

class Dashboard extends Component {
  onDashButtonClicked (name) {
    switch (name) {
      case 'dashboard':
        this.props.history.push('/company_admin')
        break
      case 'informationList':
        this.props.history.push('/company_admin/information')
        break
      case 'sharedFileList':
        this.props.history.push('/company_admin/shared_files')
        break
      case 'companyInfo':
        this.props.history.push('/company_admin/company/detail')
        break
      case 'companyUserList':
        this.props.history.push('/company_admin/company_user')
        break
      case 'personalSettingHome':
        this.props.history.push('/company_admin/personal_setting_home')
        break
      case 'surveyAnswer':
        this.props.history.push('/company_admin/survey_answer')
        break
      default:
        break
    }
  }
  onHelpLinkClicked (helpId) {
    const link = document.createElement('a')
    link.target = '_blank'
    link.href = '/company_admin/help/' + helpId
    link.rel = 'noopener noreferrer'
    link.click()
  }
  render () {
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>企業管理者マイページ<br />
                    <small>こちらから全ての作業を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9'>
                  <ul className='nav nav-tabs'>
                    <li className='active'><a onClick={(e) => this.onDashButtonClicked('dashboard')} ><i className='icon-home' />Home</a></li>
                    <li><a className='kw-btn-success' onClick={(e) => this.onDashButtonClicked('informationList')}><i className='icon-info-sign' />お知らせ</a></li>
                    <li><a className='kw-btn-warning' onClick={(e) => this.onDashButtonClicked('sharedFileList')} ><i className='icon-file' />共有ファイル</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='row'>
            <div className='span8'>
              <div className='blockoff-left'>
                <legend className='lead'>
                  ご利用方法
                </legend>
                <p>
                  利用シーンに合わせて、以下のガイドをご用意しております。
                </p>
                <h6>[日常業務]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('helpCA001', e)}>企業情報を変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('helpCA002', e)} >ユーザを登録・編集・削除する</a></li>
                </ul>
                <h6>[番外編]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help007', e)}>パスワードを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help008', e)}>メールアドレスを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help009', e)}>メール通知を受信しないように設定する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help010', e)}>サポート対象のホームページ閲覧ソフトChromeをダウンロードする</a></li>
                </ul>
              </div>
            </div>
            <div className='span8'>
              <div className='box'>
                <div className='box-header'>
                  <i className='icon-bookmark' />
                  <h5>ショートカット</h5>
                </div>
                <div className='box-content'>
                  <h6>各機能へのショートカット</h6>
                  <div className='btn-group-box'>
                    <a onClick={(e) => this.onDashButtonClicked('informationList')}><button className='btn kw-btn-success' ><i className='icon-info-sign icon-large' /><br /><span>お知らせ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('sharedFileList')}><button className='btn kw-btn-warning' ><i className='icon-file icon-large' /><br /><span>共有ﾌｧｲﾙ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('companyInfo')}><button className='btn kw-btn-info' ><i className='icon-star icon-large' /><br /><span>企業情報</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('companyUserList')}><button className='btn kw-btn-inverse' ><i className='icon-table icon-large' /><br /><span>ﾕｰｻﾞ管理</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('personalSettingHome')}><button className='btn' ><i className='icon-user icon-large' /><br /><span>個人設定</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('surveyAnswer')}><button className='btn kw-btn-default'><i className='icon-file icon-large' /><br /><span>ｱﾝｹｰﾄ回答</span></button></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/Dashboard.js